export function getDataWithArray(form) {
    let array = {};
    let objData = {};
    const formData = new FormData(form);
    for (var key of formData.keys()) {
        const value = formData.get(key);
        if (key.includes("array[")) {
            const fieldName = key.match(/array\[(.*?)\]/)[1];
            array[fieldName] = value;
        } else {
            objData[key] = value;
        }
    }
    return { array, ...objData };
}

